namespace GeniuzPOS.Administration {
    export interface PsFuncKbMapShiftCodeRow {
        Id?: number;
        KbMapShiftCode?: number;
        KbMapShiftName?: string;
    }

    export namespace PsFuncKbMapShiftCodeRow {
        export const idProperty = 'KbMapShiftCode';
        export const nameProperty = 'KbMapShiftName';
        export const localTextPrefix = 'Administration.PsFuncKbMapShiftCode';
        export const lookupKey = 'Administration.PsFuncKbMapShiftCode';

        export function getLookup(): Q.Lookup<PsFuncKbMapShiftCodeRow> {
            return Q.getLookup<PsFuncKbMapShiftCodeRow>('Administration.PsFuncKbMapShiftCode');
        }
        export const deletePermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:Modify';
        export const insertPermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:Modify';
        export const readPermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:View';
        export const updatePermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:Modify';

        export declare const enum Fields {
            Id = "Id",
            KbMapShiftCode = "KbMapShiftCode",
            KbMapShiftName = "KbMapShiftName"
        }
    }
}
